<template>
  <div class="master-baffle">
    <div class="baffeleLoginImg">
      <img src="../../../assets/images/baffleTitle.png" style="width: 120%"  alt="">
    </div>
    <p class="titleText">
      <img  src="../../../assets/images/baffleCenter.png"  alt="">
    </p>
    <div class="bafflePageBox">

      <div class="baffleTitle">

          <div class="baffleContent">
            <p class="leftTop">
              尊敬的客户：
            </p>
            <p class="contentText">
              为向您提供更加优质便捷的服务,百望数科将于2022年6月21日19:00至次日4:00进行系统升级,升级期间将暂停全部业务,在此期间给您带来不便深表歉意,感谢您长期以来对百望数科的大力支持。            </p>

            <p class="end">
              特此通告。
            </p>
            <p class="time">2022年6月21日</p>
          </div>
      </div>
    </div>
      <div class="bottomImg">
        <img src="../../../assets/images/baffleBottom.png" style="width: 100%" alt="">
      </div>
  </div>
</template>

<script>
export default {
  name: 'master-baffle',
  data() {
    return {};
  },
};
</script>
<style scoped>
.contentText {
    text-indent: 2em;
    text-align: left;

}
.leftTop{
  text-align: left;
}
  .end{
    text-align: right;
  }
  .master-baffle{
    background-color: #2477EB;
    overflow: hidden;
  }
  .titleText{
    width:100%;
    background-color:#2477EB;
    margin-top:-7px;
  }
  .titleText img{
    width:80%;
    margin:0 auto;
    display: block;
  }

  .bafflePageBox{
    padding: 10px;
    color: #fff;
    line-height: 40px;
    word-break:break-all;
    padding: 0 15px;
    font-size:12px;
  }
  p.time{
    width: 100%;
    text-align: right;
  }
</style>
